import { Injectable, inject } from "@angular/core";
import { Router } from "@angular/router";

import { Action, Selector, State, StateContext } from "@ngxs/store";
import { catchError, switchMap, tap, throwError, timer } from "rxjs";

import {
  AddItemToWishlistAction,
  AddToWishlistAction,
  DeleteWishlistAction,
  GetAddedItemFromWishlistAction,
  GetWishlistAction,
  RemoveWishlistItemAction,
} from "../action/wishlist.action";
import { _IProduct, IProduct } from "../interface/product.interface";
import { WishlistService } from "../services/wishlist.service";
import { IApiResponse } from "../interface/api-response.interface";
import { _IWishlistModel } from "../interface/wishlist.interface";

export class WishlistStateModel {
  wishlist = {
    data: [] as IProduct[],
    total: 0,
  };
  createResult: IApiResponse | null;
  removeResult: IApiResponse | null;
  wishlistProducts: any;
  wishlistCount: number;
}

@State<WishlistStateModel>({
  name: "wishlist",
  defaults: {
    wishlist: {
      data: [],
      total: 0,
    },
    createResult: null,
    removeResult: null,
    wishlistProducts: null,
    wishlistCount: 0,
  },
})
@Injectable()
export class WishlistState {
  router = inject(Router);
  private wishlistService = inject(WishlistService);

  @Selector()
  static wishlistItems(state: WishlistStateModel) {
    return state.wishlist;
  }

  @Selector()
  static wishlistProducts(state: WishlistStateModel) {
    return state.wishlistProducts;
  }

  @Selector()
  static wishlistCount(state: WishlistStateModel) {
    return state.wishlistCount;
  }

  @Selector()
  static RemovedWishlistProducts(state: WishlistStateModel) {
    return state.removeResult;
  }

  @Action(GetWishlistAction)
  getWishlistItems(ctx: StateContext<GetWishlistAction>) {
    this.wishlistService.skeletonLoader = true;
    return this.wishlistService.getWishlistItems().pipe(
      tap({
        next: (result) => {
          ctx.patchState({
            wishlist: {
              data: result.data,
              total: result?.total
                ? result?.total
                : result.data
                  ? result.data.length
                  : 0,
            },
          });
        },
        complete: () => {
          this.wishlistService.skeletonLoader = false;
        },
        error: (err) => {
          throw new Error(err?.error?.message);
        },
      })
    );
  }

  @Action(AddToWishlistAction)
  add(_ctx: StateContext<WishlistStateModel>, _action: AddToWishlistAction) {
    // Add Wishlist Logic Here
    void void this.router.navigate(["/wishlist"]);
  }

  @Action(DeleteWishlistAction)
  delete(ctx: StateContext<WishlistStateModel>, { id }: DeleteWishlistAction) {
    const state = ctx.getState();
    let item = state.wishlist.data.filter((value) => value.id !== id);
    ctx.patchState({
      wishlist: {
        data: item,
        total: state.wishlist.total - 1,
      },
    });
  }

  //My Wishlist
  // @Action(AddItemToWishlistAction)
  // addItemToWishlist(
  //   ctx: StateContext<WishlistStateModel>,
  //   action: AddItemToWishlistAction
  // ) {
  //   return this.wishlistService.AddToWishlist(action.item).pipe(
  //     tap({
  //       next: (result) => {
  //         setTimeout(
  //           () => ctx.dispatch(new GetAddedItemFromWishlistAction()),
  //           3000
  //         );
  //       },
  //       error: (err) => {
  //         console.error("Error adding wishlist item:", err);
  //         throw new Error(err?.error?.message);
  //       },
  //     })
  //   );
  // }
  @Action(AddItemToWishlistAction)
  addItemToWishlist(
    ctx: StateContext<WishlistStateModel>,
    action: AddItemToWishlistAction
  ) {
    return this.wishlistService
      .AddToWishlist(action.item)
      .pipe(
        switchMap(() => ctx.dispatch(new GetAddedItemFromWishlistAction()))
      );
  }

  @Action(GetAddedItemFromWishlistAction)
  getAddedItemFromWishlist(
    ctx: StateContext<WishlistStateModel>,
    action: GetAddedItemFromWishlistAction
  ) {
    return this.wishlistService.loadWishlistItems().pipe(
      tap({
        next: (result) => {
          ctx.patchState({
            wishlistProducts: result.data,
            wishlistCount: result.data.cartItems.length,
          });
        },
        error: (err) => {
          console.error("Error fetching wishlist items:", err);
          // throw new Error(err?.error?.message);
          return throwError(() => new Error(err?.error?.message));
        },
      })
    );
  }

  @Action(RemoveWishlistItemAction)
  removeWishlistItem(
    ctx: StateContext<WishlistStateModel>,
    { id }: RemoveWishlistItemAction
  ) {
    return this.wishlistService.removeWishlistItem(id).pipe(
      tap({
        next: (result) => {
          ctx.dispatch(new GetAddedItemFromWishlistAction());
        },
        error: (err) => {
          console.error("Error removing wishlist item:", err);
          throw new Error(err?.error?.message);
        },
      })
    );
  }
}
